import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import LanguageContext from '@lib/contexts/languageContext';
import { Trans } from '@lingui/react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ButtonFavoritePlaylistCard from '@components/ButtonFavoritePlaylistCard';
import { StyledMaterialButton } from '@components/buttons';
import Icon from '@components/Icon';
import { Box } from '@components/layout/Grid';
import ButtonDeletePlaylist from '@ecosystems/ButtonDeletePlaylist';
import ButtonEditPlaylist from '@ecosystems/ButtonEditPlaylist';
import MenuItemShareModal from '@ecosystems/MenuItemShareModal';
import Card from './Card';
import { Playlist } from '@gql/generated';

const Bar = styled.div`
  position: absolute;
  background-color: rgba(136, 191, 189, 0.9);
  right: 0;
  top: 0;
  bottom: 0;
  width: 100px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Meta = styled.span`
  color: white;
  font-size: 10px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 5px;
`;

type Props = {
  className?: string;
  disableActionButtons?: boolean;
  appearance?: { large?: boolean };
  playlist: {
    id: string;
    title: string;
    visibility?: string;
    description: string;
    thumbnailUrl: string;
    duration: number;
    videoCount: number;
    createdBy: React.ReactNode;
    identifier: string;
    ownerId: string;
  };
};

const PlaylistCard = (props: Props) => {
  const { disableActionButtons = false } = props;
  const locale = useContext(LanguageContext);
  const [anchorElMenu, setAnchorElMenu] = useState(null);

  const handleOpenMenu = event => {
    setAnchorElMenu(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorElMenu(null);
  };

  return (
    <Card
      className={props.className}
      large={props.appearance ? props.appearance.large : null}
      redirectTo={`/${locale}/playlists/${props.playlist.identifier}`}
      thumbnailUrl={props.playlist.thumbnailUrl}
      thumbnailContent={
        <Bar>
          <Box mb="10px">
            <Icon name="ygb-icon-playlist" color="white" fontSize="30px" />
          </Box>
          <Meta>
            {props.playlist.videoCount}{' '}
            <Trans id="metadata.videos" message={`Videos`} />
          </Meta>
          <Meta>
            {props.playlist.duration} <Trans id="metadata.min" />
          </Meta>
        </Bar>
      }
      contentTitle={props.playlist.title}
      contentAuthor={props.playlist.createdBy}
      contentDescription={props.playlist.description}
      contentCardLeftSection={
        disableActionButtons ? null : (
          <ButtonFavoritePlaylistCard playlistId={props.playlist.id} />
        )
      }
      contentCardRightSection={
        disableActionButtons ? null : (
          <React.Fragment>
            <StyledMaterialButton onClick={handleOpenMenu}>
              <Icon name="ygb-icon-menu-hor" fontSize="5px" />
            </StyledMaterialButton>
            <Menu
              id="playlist-card-menu"
              anchorEl={anchorElMenu}
              keepMounted
              open={Boolean(anchorElMenu)}
              onClose={handleCloseMenu}
            >
              <ButtonEditPlaylist
                tag={MenuItem}
                playlist={{
                  id: props.playlist.id,
                  title: props.playlist.title,
                  description: props.playlist.description,
                  visibility: props.playlist.visibility,
                  ownerId: props.playlist.ownerId,
                }}
              />
              {/* <ButtonScheduleModal
                    tag={MenuItem}
                    resource="playlist"
                    resourceId={props.playlist.id}
                  /> */}
              <MenuItemShareModal
                resourceIdentifier={props.playlist.identifier}
                resource="playlists"
                playlist={{
                  id: props.playlist.id,
                  title: props.playlist.title,
                  description: props.playlist.description,
                  visibility: props.playlist.visibility,
                  ownerId: props.playlist.ownerId,
                }}
                onModalClose={handleCloseMenu}
              />
              <ButtonDeletePlaylist
                tag={MenuItem}
                playlist={{
                  id: props.playlist.id,
                  title: props.playlist.title,
                  description: props.playlist.description,
                  visibility: props.playlist.visibility,
                  ownerId: props.playlist.ownerId,
                  videoCount: props.playlist.videoCount,
                }}
              />
            </Menu>
          </React.Fragment>
        )
      }
      contentLeftCardLargeSection={
        disableActionButtons
          ? []
          : [
              <ButtonFavoritePlaylistCard
                key="1"
                playlistId={props.playlist.id}
              />,
              <ButtonEditPlaylist
                key="3"
                tag={StyledMaterialButton}
                playlist={{
                  id: props.playlist.id,
                  title: props.playlist.title,
                  description: props.playlist.description,
                  visibility: props.playlist.visibility,
                  ownerId: props.playlist.ownerId,
                }}
              />,
              <ButtonDeletePlaylist
                key="2"
                tag={MenuItem}
                playlist={{
                  id: props.playlist.id,
                  title: props.playlist.title,
                  description: props.playlist.description,
                  visibility: props.playlist.visibility,
                  ownerId: props.playlist.ownerId,
                  videoCount: props.playlist.videoCount,
                }}
              />,
              // <ButtonScheduleModal
              //   tag={StyledMaterialButton}
              //   resource="playlist"
              //   resourceId={props.playlist.id}
              // />,
            ]
      }
      contentRightCardLargeSection={
        disableActionButtons ? null : (
          <React.Fragment>
            <StyledMaterialButton onClick={handleOpenMenu}>
              <Icon name="ygb-icon-menu-hor" fontSize="5px" />
            </StyledMaterialButton>
            <Menu
              anchorEl={anchorElMenu}
              open={!!anchorElMenu}
              onClose={handleCloseMenu}
            >
              <MenuItemShareModal
                resourceIdentifier={props.playlist.identifier}
                resource="playlists"
                playlist={{
                  id: props.playlist.id,
                  title: props.playlist.title,
                  description: props.playlist.description,
                  visibility: props.playlist.visibility,
                  ownerId: props.playlist.ownerId,
                }}
              />
            </Menu>
          </React.Fragment>
        )
      }
    />
  );
};

export default PlaylistCard;
